import { render, staticRenderFns } from "./PhoAutocomplete.vue?vue&type=template&id=7ecc67a0&lang=pug"
import script from "./PhoAutocomplete.vue?vue&type=script&lang=js"
export * from "./PhoAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports